import { Trait } from '../../trait.type';
import { TraitRegistry, TraitType } from '../../trait-registry';
import { addModifier } from '../../player.type';
import { StatusEffect } from '../../status-effects.type';

export class SwarmTrait extends Trait {
  static baseType = TraitType.Swarm;
  static baseTitle = 'Swarm';
  static baseText =
    'On the start of turn, set Powerful for every 10% current HP higher than 50% max HP, or set Weakness for every 10% current HP lower than 50% max HP.';
  static baseIcon = 'trait';

  type = SwarmTrait.baseType;
  title = SwarmTrait.baseTitle;
  text = SwarmTrait.baseText;
  icon = SwarmTrait.baseIcon;

  beforeStartTurn() {
    if (!this.owner) {
      return;
    }
    const hpPercent = this.owner.healthCurrent / this.owner.healthMax;
    let powerful = this.owner.statusEffects.find((modifier) => {
      return modifier.type == StatusEffect.Powerful;
    });
    let weakness = this.owner.statusEffects.find((modifier) => {
      return modifier.type == StatusEffect.Weakness;
    });

    if (hpPercent > 0.5) {
      // if has modifier powerful, set stacks to 0
      if (powerful) {
        powerful.stacks = Math.ceil((hpPercent - 0.5) * 10);
      } else {
        addModifier(this.owner, StatusEffect.Powerful, Math.ceil((hpPercent - 0.5) * 10));
      }
      if (weakness) {
        weakness.removeStacks(weakness.stacks);
      }
    } else {
      // if has modifier weakness, set stacks to 0
      if (weakness) {
        weakness.stacks = Math.ceil((0.5 - hpPercent) * 10);
      } else {
        addModifier(this.owner, StatusEffect.Weakness, Math.ceil((0.5 - hpPercent) * 10));
      }
      if (powerful) {
        powerful.removeStacks(powerful.stacks);
      }
    }
  }
}

TraitRegistry.register(SwarmTrait.baseType, SwarmTrait);
